<template lang="pug">
    .shop-tabs(v-if="enabledExtensions.includes('shop')")
        tabs(:items="tabs" :active-tab="activeTab" @click="activateTab")
            template(slot="tabbar-buttons")
                slot(name="tabbar-buttons")
        slot
    .full-height-error(v-else)
        Error(:message="null" :code="403")
</template>

<i18n>
{
    "de": {
        "Products": "Produkte",
        "Categories": "Kategorien",
        "Attribute sets": "Attribut-Sets",
        "Attributes": "Attribute",
        "Sub-Articles": "Unterartikel"
    }
}
</i18n>

<script>
import Tabs from '@/components/Tabs';
import Error from '@/components/Error';
import { useSetupStore } from '@/stores';

export default {
    name: 'CatalogTabs',
    components: {
        Tabs,
        Error
    },
    computed: {
        tabs() {
            return [
                {
                    name: this.$t('Products'),
                    path: '/catalog/products',
                    icon: {
                        name: 'tag',
                        group: 'fas'
                    }
                },
                {
                    name: this.$t('Sub-Articles'),
                    path: '/catalog/articles',
                    icon: {
                        name: 'tags',
                        group: 'fas'
                    }
                },
                {
                    name: this.$t('Categories'),
                    path: '/catalog/category',
                    icon: {
                        name: 'folder',
                        group: 'far'
                    }
                },
                {
                    name: this.$t('Attribute sets'),
                    path: '/catalog/property-sets',
                    icon: {
                        name: 'cubes',
                        group: 'fas'
                    }
                },
                {
                    name: this.$t('Attributes'),
                    path: '/catalog/properties',
                    icon: {
                        name: 'cube',
                        group: 'fas'
                    }
                },
            ];
        },
        activeTab() {
            return this.$route.matched[0].path;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        }
    },
    methods: {
        activateTab(item) {
            return useSetupStore().activateTab(item)
        }
    }
};
</script>
